import React from "react";

export function PageHeader({ title, description, icon: Icon, children, testid }) {
  return (
    <div className="page-head" data-testid={testid}>
      <div className="min-w-0">
        <h1 className="page-title">{Icon && <span className="page-icon"><Icon size={18} /></span>}<span className="truncate">{title}</span></h1>
        {description && <p className="page-sub">{description}</p>}
      </div>
      {children && <div className="page-actions">{children}</div>}
    </div>
  );
}
